import axios from 'axios'

const state = {
  bundlesList: [],
  bundlesSingle: null,
}

const getters = {
  getBundlesList (state) {
    return state.bundlesList
  },
  getBundlesSingle (state) {
    return state.bundlesSingle
  },
}

const mutations = {
  setBundlesList (state, payload) {
    state.bundlesList = payload
  },
  setBundlesSingle (state, payload) {
    state.bundlesSingle = payload
  },
  clearBundlesSingle (state) {
    state.bundlesSingle = null
  },
}

const actions = {
  fetchBundlesList ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/bundlesList']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setBundlesList', res.data.items)

        return res
      })
      .catch((err) => err)
  },
  fetchSingleBundles ({ commit, rootGetters }, id) {
    return axios
      .get(rootGetters['api/bundlesSingle'](id))
      .then((res) => {
        commit('setBundlesSingle', res.data.data)

        return res
      })
      .catch((err) => err)
  },
  createBundles ({ rootGetters }, data) {
    return axios
      .post(rootGetters['api/bundlesCreate'], data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  editBundles ({ rootGetters }, { data, id }) {
    return axios
      .put(rootGetters['api/bundlesEdit'](id), data)
      .then((res) => {
        return res
      })
      .catch((err) => err)
  },
  deleteBundles ({ commit, getters, rootGetters }, id) {
    return axios
      .delete(rootGetters['api/bundlesDelete'](id))
      .then((res) => {
        if (res.status === 200) {
          const items = getters.getBundlesList.filter((val) => val.id !== id)
          commit('setBundlesList', items)
        }

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
